import createSvgIcon from '../Utils/CreateSvgIcon';

export const Satnav = createSvgIcon(
  <path
    d="M11.912 12.9984L2.99987 9.73748L20.8103 3.10145L15.4329 21.3314L11.912 12.9984ZM15.0976 15.3992L13.4159 11.419L8.77381 9.72047L17.7604 6.37216L15.0976 15.3992Z"
    fillRule="evenodd"
  />,
  'Satnav',
);
